import { useAuth, type Agency, type Team } from "~/context/AuthContext";

export function useActiveTeam(): Team | undefined {
  const { user } = useAuth();
  return user?.teams?.find((team) => team.id === user.team_id);
}

export function useTeamAgency(): Agency | null {
  const { user } = useAuth();
  const activeTeam = useActiveTeam();
  const agency = user?.agency ?? null;
  if (!agency) return null;
  const isOutsideAgency =
    activeTeam?.agency_id !== undefined && activeTeam.agency_id !== agency.id;
  return isOutsideAgency ? null : agency;
}

export function useIsAgencyClient(): boolean {
  const activeTeam = useActiveTeam();
  const teamAgency = useTeamAgency();
  return Boolean(activeTeam?.agency_id) && !teamAgency;
}

export function useIsTeamViewer(): boolean {
  return useActiveTeam()?.role === "viewer";
}

export function useIsReadOnlyTeam(): boolean {
  const activeTeam = useActiveTeam();
  if (activeTeam?.role === "viewer") return true;
  return (
    Boolean(activeTeam?.is_pitch) &&
    activeTeam?.pitch_status !== "draft" &&
    activeTeam?.pitch_status !== "failed"
  );
}
